import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { customEventUpd } from "@/api/customizationEvents/customizationEvents";
export default {
  data: function data() {
    return {
      paramsData: {
        id: '',
        event_name: '',
        event: ''
      },
      paramsDataMark: {},
      dialogShow: false,
      rules: {
        event_name: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        event: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }]
      },
      currencyList: []
    };
  },
  created: function created() {
    this.paramsDataMark = JSON.parse(JSON.stringify(this.paramsData));
  },
  methods: {
    open: function open(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  _this.paramsData = _objectSpread({}, data);
                }

                _this.dialogShow = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    clearData: function clearData(isClearId) {
      this.paramsData = _objectSpread(_objectSpread({}, this.paramsDataMark), {}, {
        id: isClearId ? '' : this.paramsData.id
      });
      this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          customEventUpd(_objectSpread({}, _this2.paramsData)).then(function (res) {
            if (res.status == 200) {
              _this2.$message({
                message: '操作成功',
                type: 'success'
              });

              _this2.dialogShow = false;

              _this2.$emit('change');
            }
          });
        }
      });
    }
  }
};